// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>

export function fmtInt(n: number): string {
  return Math.round(n).toLocaleString('en-AU');
}

export function fmtPct(n: number, dp = 1): string {
  return `${n.toFixed(dp)}%`;
}

/** A swing/margin with an explicit sign, e.g. "+7.7" or "−1.8". */
export function fmtSigned(n: number, dp = 1): string {
  const s = n.toFixed(dp);
  if (n > 0) return `+${s}`;
  return s.replace('-', '−'); // real minus sign
}

/** Escape for use as an HTML text node / attribute value via innerHTML. */
export function esc(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Escape for a data-tip attribute placed via innerHTML: newlines -> &#10;. */
export function escTip(s: string): string {
  return esc(s).replace(/\n/g, '&#10;');
}

export function fullName(given: string, surname: string): string {
  // AEC surnames are upper-case; title-case them for display.
  const sn = surname
    .toLowerCase()
    .replace(/(^|[\s'’\-])([a-z])/g, (_, p, c) => p + c.toUpperCase());
  return `${given} ${sn}`.trim();
}

export function slug(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}
